var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5.5-Queue-/-Registration---view-patient-registration",
    transform: "translate(-388.000000, -518.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(368.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.Health-screening/Register/Patient-info",
    transform: "translate(0.000000, 16.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project",
    transform: "translate(20.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.21875,3.24999996 C11.3050445,3.24999996 11.375,3.31995546 11.375,3.40624996 L11.375,8.87499998 C11.375,9.9105339 12.2144661,10.75 13.25,10.75 L18.71875,10.75 C18.8050445,10.75 18.875,10.8199555 18.875,10.90625 L18.875,18.25 C18.875,19.6307119 17.7557119,20.75 16.375,20.75 L7.62499997,20.75 C6.2442881,20.75 5.12499997,19.6307119 5.12499997,18.25 L5.12499997,5.74999996 C5.12499997,4.36928809 6.2442881,3.24999996 7.62499997,3.24999996 Z M12.6732718,3.73242829 C12.7023785,3.72039297 12.7358656,3.72701318 12.7582031,3.74921871 L18.3757813,9.36679686 C18.3979868,9.38913436 18.404607,9.4226215 18.3925717,9.45172821 C18.3805364,9.48083492 18.3521997,9.49986775 18.3207032,9.49999999 L13.25,9.49999999 C12.904822,9.49999999 12.625,9.22017795 12.625,8.87499998 L12.625,3.80429683 C12.6251322,3.7728003 12.6441651,3.74446362 12.6732718,3.73242829 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.17f17809.svg";
export { ForwardRef as ReactComponent };